// extracted by mini-css-extract-plugin
export var buttonContent = "_2u-0";
export var centered = "_2u-1";
export var centeredFlex = "_2u-2";
export var errorText = "_2u-3";
export var icon = "_2u-4";
export var iconButtonContent = "_2u-5";
export var monospace = "_2u-6";
export var padded = "_2u-7";